import { genericRequest } from 'app/api';

export async function submitForm(id, values, intl, setIsLoading) {
  const response = await genericRequest({
    url: 'customers/me',
    method: 'patch',
    data: {
      data: {
        id,
        type: 'customer',
        attributes: {
          walletPackPayment: values.isActivatePaymentByWallet
        }
      }
    },
    setLoading: setIsLoading,
    customSuccessFeedback: {
      variant: 'success',
      content: intl.formatMessage({
        id: 'controlpanel.feedback.save_changes.success'
      }),
      autoClose: true,
      dismissible: false
    }
  });

  return response;
}
